{
	"backLinkTitle": "Zurück zur Verwaltung der Erklärungen",
	"invoicedQuantity": "Abgerechnete Menge",
	"remainingForDeclarationCreation": "Verbleibend für die Erstellung der Erklärung",
	"nonTransferableAmount": "Nicht zuordenbare Menge",
	"btnCreateDeclaration": "+ Erklärung erstellen",
	"errorMessage": "Laden der Materialdetails fehlgeschlagen"
}
